import { Box } from '@material-ui/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import TitleText from './TitleText';
const FlightDealCard = ({ item, index }) => {
	const [toggle, setToggle] = useState(false);
	const history = useHistory();
	return (
		<>
			<Box
				onClick={() => history.push(`/flightdeal/${item.title}`)}
				onMouseEnter={() => {
					toggle ? setToggle(false) : setToggle(true);
				}}
				onMouseLeave={() => {
					toggle ? setToggle(false) : setToggle(true);
				}}
				style={{
					boxShadow: '0 4px 8px 0 rgb(0 0 0 / 20%)',
					borderRadius: 12,
					cursor: 'pointer',
					background: toggle
						? 'linear-gradient(45deg, #3f51b5, transparent)'
						: '',
					color: toggle ? 'white' : 'black',
				}}>
				<img
					src={item.image}
					style={{
						height: 200,
						width: '100%',
						borderTopLeftRadius: 12,
						borderTopRightRadius: 12,
					}}></img>
				<Box style={{ padding: 20 }}>
					<TitleText textStyle={{ fontSize: 26 }}>{item.title}</TitleText>
				</Box>
			</Box>
		</>
	);
};

export default FlightDealCard;
